module.exports = __webpack_public_path__ + "img/fedex_icon.b247851a.svg";